import React, { useMemo, useState } from "react";

import TrainerMasterModal from "./TrainerMasterModal";
// import {
//   deleteAllTrainer,
//   getAllTrainerList,
//   getAllTrainerName,
// } from "../../../services/common/trainer/TrainerServices";
import { useForm } from "react-hook-form";
import { getAllTrainerList } from "../../services/Trainer/TrainerServices";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import CommonHeading from "../../../../../common/components/Custom Hooks/CommonHeading";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../../../common/components/loadingspinner/loadingSpinner";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import { DeleteIcon, EditIcon } from "../../../../../assets/CommonAssets";

/****************** user actions configuration ******************/
const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

const Trainer = () => {
  /****************** state variables ******************/
  const [trainerModalOpen, setTrainerModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [trainerList, setTrainerList] = useState([]);
  const [trainerNameOptions, setTrainerNameOptions] = useState([]);
  const [count, setCount] = useState(0);
  const [listingObject, setListingObject] = useState({
    searchString: "",
    page: page,
    size: rowsPerPage,
    searchId: null,
    menuId: null,
  });
  const { control, setValue, watch } = useForm();

  /****************** form handling functions ******************/
  const populateTable = (forPagination) => {
    let tempObj = { ...listingObject, page: !forPagination ? 0 : page };

    if (page === 0) {
      showSpinner(true);
    }
    getAllTrainerList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        console.log("resssssssss", res);
        if (res.statusCode === 200 || res.statusCode === 204) {
          console.log("forPaginationforPagination", forPagination);
          if (forPagination) {
            setTrainerList((prevData) => [...prevData, ...res.result]);
          } else {
            setTrainerList(res.result);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);

  //     if (selectedRow !== null) {
  //       deleteAllTrainer(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           // console.log("aaaaaaaaaaa", res);
  //           successAlert(res.message);
  //           // setPage(0)
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setTrainerModalOpen(false);
  //           setSelectedRow(null);
  //           errorAlert(errors.message);
  //         });
  //     }
  //   };

  /****************** renderActions function ******************/
  console.log(selectedRow, "selectedRow");
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Edit" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setTrainerModalOpen(true);
                        setSelectedRow(row);
                      }}
                    >
                      <EditIcon title={"Edit"} sx={{ color: "gray" }} />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Edit" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setSelectedRow(row);
                      }}
                    >
                      <DeleteIcon
                        sx={{ color: "#D11A2A" }}

                        // onClick={() => deleteRow(row)}
                      />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  /****************** renderInput ********************/
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${
                       row?.Status === true
                         ? "text-customGreen border-customGreen"
                         : "text-customRed border-customRed"
                     }`}
            type="button"
          >
            {row?.Status === true ? "Active" : "InActive"}
          </button>
        )}
      </>
    );
  };

  useMemo(() => {
    populateTable();
  }, [listingObject.searchId, listingObject.searchString]);

  return (
    <div className="px-2 my-1">
      {CommonHeading("Trainer")}

      <div className="flex gap-2 w-full items-center mt-2">
        <div className="flex w-full lg:grid grid-cols-2 gap-2 items-center">
          <div className="grid w-full grid-cols-1">
            <SearchDropdown
              control={control}
              name="SearchableSelect"
              placeholder="Search by Trainer"
              isSearchable={true}
              searchIcon={true}
              dataArray={trainerNameOptions}
              handleInputChange={(e) => {
                //     const tempCheckChar =
                //       e !== null ? UseCheckConsecutiveCharacters(e) : true;
                //     if (e !== "" && tempCheckChar) {
                //       getAllTrainerName(e)
                //         .then((response) => {
                //           setTrainerNameOptions(response.data.result);
                //         })
                //         .catch((error) => {
                //           console.log(error);
                //         });
                //     } else {
                //       setTrainerNameOptions([]);
                //     }
                //   }}
                //   onChange={(e) => {
                //     if (e !== "") {
                //       setSearchString(e);
                //     } else {
                //       setSearchString(null);
                //     }
              }}
              isClearable={true}
            />
          </div>
          <div>
            <CommonButton
              className="bg-customBlue text-white"
              searchIcon={true}
              onClick={() =>
                setListingObject({
                  searchString: searchString,
                  page: page,
                  size: rowsPerPage,
                  searchId: watch("SearchableSelect")
                    ? watch("SearchableSelect").id
                    : null,
                  menuId: null,
                })
              }
            />
          </div>
        </div>
        <div className="grid justify-end xl:col-span-3 w-1/3">
          {userActions &&
            userActions.map((obj) => (
              <>
                {!obj.isAction && obj.permission === "Create" ? (
                  <CommonButton
                    onClick={() => setTrainerModalOpen(true)}
                    label="+ New"
                    className="modalButton bg-customBlue text-white"
                  />
                ) : null}
              </>
            ))}
        </div>
      </div>
      {spinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}

      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      {trainerModalOpen && (
        <TrainerMasterModal
          setTrainerModalOpen={setTrainerModalOpen}
          trainerModalOpen={trainerModalOpen}
          // setTrainerData={setTrainerData}
          // trainerData={trainerData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          populateTable={populateTable}
          openBackDrop={openBackDrop}
          setOpenBackdrop={setOpenBackdrop}
        />
      )}
      <div>
        {trainerList?.length > 0 && !spinner ? (
          <CommonTransactionPaginationTable
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            populateTable={populateTable}
            count={count}
            highlightRow={false}
            dataResult={trainerList}
            renderActions={renderActions}
            renderInput={renderInput}
            editableColumns={"Status"}
            removeHeaders={["Id", "Trainer Description"]}
            tableClass="capitalize"
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                  No Records Found...
                </h3>
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmationModal
        confirmationOpen={openDeleteModal}
        confirmationHandleClose={() => {
          setOpenDeleteModal(false);
          setSelectedRow(null);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to delete this record?"
        confirmationSubmitFunc={() => {
          // handleDelete
        }}
        confirmationButtonMsg="Delete"
      />
    </div>
  );
};

export default Trainer;
